// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u1bRT","newExpiryDate":"styles_newExpiryDate__jlW5Z","footer":"styles_footer__1FH-e"};